import React from "react"
import {FieldFormElementViewProps} from "../../render/form-elemnent-view";

export default function FieldProto_FormElementView(props: FieldFormElementViewProps) {

    return (
        <div className="ui5-txt-default ui5-txt-red">{props.field.type}.formElementView</div>
    )

}